import { createDraftSafeSelector } from "@reduxjs/toolkit";
import { stateAccountsSelector } from "../slice-data/stateAccountsSelector";
import { accountsGroupedByProviderCombiner } from "../../combiners/accountsGroupedByProviderCombiner";

export const allAccountsGroupedByProviderSelector = createDraftSafeSelector(
  [stateAccountsSelector],
  accountsGroupedByProviderCombiner,
);
